/**
 * Service for handling localStorage operations
 */
class StorageService {
    /**
     * Store value in localStorage
     * @param key - Storage key
     * @param value - Value to store
     * @returns Operation success status
     */
    setItem(key, value) {
        try {
            localStorage.setItem(key, JSON.stringify(value));
            return true;
        }
        catch (error) {
            console.error('Storage set error:', error);
            return false;
        }
    }
    /**
     * Get value from localStorage
     * @param key - Storage key
     * @returns Stored value or null if not found
     */
    getItem(key) {
        try {
            const item = localStorage.getItem(key);
            return item ? JSON.parse(item) : null;
        }
        catch (error) {
            console.error('Storage get error:', error);
            return null;
        }
    }
    /**
     * Remove value from localStorage
     * @param key - Storage key
     * @returns Operation success status
     */
    removeItem(key) {
        try {
            localStorage.removeItem(key);
            return true;
        }
        catch (error) {
            console.error('Storage remove error:', error);
            return false;
        }
    }
    /**
     * Remove multiple values from localStorage
     * @param keys - Array of storage keys
     * @returns Operation success status
     */
    removeItems(keys) {
        try {
            keys.forEach((key) => localStorage.removeItem(key));
            return true;
        }
        catch (error) {
            console.error('Storage removeItems error:', error);
            return false;
        }
    }
    /**
     * Clear all localStorage
     * @returns Operation success status
     */
    clear() {
        try {
            localStorage.clear();
            return true;
        }
        catch (error) {
            console.error('Storage clear error:', error);
            return false;
        }
    }
}
const storageService = new StorageService();
export default storageService;
//# sourceMappingURL=storageService.js.map